export default "__VITE_ASSET__Dxy$3IoX__"